import React from 'react';

/** Centered gate card used when a shell page needs sign-in or lacks access. */
const ShellGate = ({ icon: Icon, eyebrow, title, body, children }) => (
  <div className="min-h-[60vh] flex items-center justify-center px-4">
    <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-200/80 p-8 text-center">
      {Icon && (
        <div className="w-12 h-12 rounded-2xl bg-red-50 text-designer-primary flex items-center justify-center mx-auto mb-4 border border-red-100/60">
          <Icon className="w-5 h-5" />
        </div>
      )}
      {eyebrow && (
        <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-designer-primary mb-2">{eyebrow}</p>
      )}
      <h1 className="text-xl font-bold text-designer-dark mb-2">{title}</h1>
      {body && <p className="text-sm text-gray-500 leading-relaxed mb-6">{body}</p>}
      {children && <div className="flex flex-col sm:flex-row gap-2 justify-center">{children}</div>}
    </div>
  </div>
);

export default ShellGate;
